import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Icon from "nekrasovka-ui/Icons";
import editing from "modules/editing";

const { editingToggle } = editing.actions;

const MentionItem = styled.div`
  svg {
    display: none;
    margin-right: 10px;
  }

  &,
  * {
    font-family: Merriweather, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 22px;
  }

  &.mention_edit:hover {
    color: #eb5757;
    cursor: pointer;

    svg {
      display: inline-block;
    }
  }

  a.mention-link:hover {
    text-decoration: underline;
  }
`;

class Mention extends React.Component {
  handleEditMention = () => {
    this.props.editingToggle(this.props.mention, "mention");
  };

  render() {
    const { mention } = this.props;
    const isEdit = this.props.edit;
    const isMentionUrl = !!mention.url;
    const mentionLinkClass = isMentionUrl && !isEdit ? "mention-link" : "";
    const mentionLinkHref = !isEdit ? mention.url : null;
    const mentionClass = isEdit ? "mention_edit" : "";

    return (
      <MentionItem
        className={mentionClass}
        onClick={isEdit ? this.handleEditMention : null}
      >
        <Icon icon="pencil" fill="#EB5757" height={12} width={12} />
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={mentionLinkHref}
          className={mentionLinkClass}
          style={{ marginRight: "10px" }}
        >
          {mention.magazine}. {mention.year}.{" "}
          {mention.edition_id ? mention.edition_id + "-е изд." : ""}{" "}
          {mention.magazine_id === 2 ? "книга" : "Т."} {mention.volume},{" "}
          {mention.numbers}.
        </a>
        {mention.pages.length !== 0 && mention.pages.length !== undefined
          ? "C. "
          : mention.page}
        {mention.pages.map((page, index) => {
          const pageLinkClass = !isEdit && page.url ? "mention-link" : "";
          const pageLinkHref = !isEdit ? page.url : null;

          return (
            <a
              key={index}
              target="_blank"
              rel="noopener noreferrer"
              href={pageLinkHref}
              className={pageLinkClass}
            >
              {page.title}
              {page.comment !== null ? `(${page.comment})` : ""}
              {mention.pages[index + 1] !== undefined ? ", " : "."}
            </a>
          );
        })}
      </MentionItem>
    );
  }
}

const mapStateToProps = (state) => ({
  editing: state.editing.editing,
});

export default connect(mapStateToProps, { editingToggle })(Mention);



// WEBPACK FOOTER //
// ./src/containers/Mention/index.js